import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.institutes');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-page-institutes',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.institutes/view.scss */
/* src/app/page.institutes/view.scss: no such file or directory */`],
})
export class PageInstitutesComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public insID: any;
    public mode: any;
    public item: any;

    public async ngDoCheck() {
        this.insID = WizRoute.segment.id;
        this.mode = WizRoute.segment.mode;
        this.item = WizRoute.segment.item;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        // this.title.setTitle("기관현황 - MY KREONET");
    }
}

export default PageInstitutesComponent;